import 'components/AdminLayout/scss/grid.global.scss';

import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak, { keycloakLogout } from './config/keycloak';

import { useUnit } from 'effector-react';
import { $user } from 'models/user';
import { KeycloakTokenParsed } from 'keycloak-js';

import AppRouter from './AppRouter';
import { useNavigate } from 'react-router-dom';

const eventLogger = async (event: unknown, error: unknown) => {
	console.log('onKeycloakEvent', event, error);

	if (event === 'onTokenExpired') {
		try {
			const refreshed = await keycloak.updateToken(30);
			if (!refreshed) {
				keycloakLogout(keycloak);
			}
		} catch (e) {
			console.error('Ошибка при обновлении токена:', e);
			keycloakLogout(keycloak);
		}
	}
};

function App() {
	const user = useUnit($user);
	const navigate = useNavigate();

	const tokenLogger = (tokens: any) => {
		console.log('onKeycloakTokens', tokens);

		const tokenParsed: KeycloakTokenParsed = keycloak.tokenParsed!;

		if (tokenParsed && user && tokenParsed?.groups?.length !== user?.groups?.length) {
			const encodedRef = encodeURIComponent(location.pathname + location.search);
			navigate(`/login?ref=${encodedRef}`);
		}
	};

	return (
		<ReactKeycloakProvider authClient={keycloak} onEvent={eventLogger} onTokens={tokenLogger}>
			<AppRouter />
		</ReactKeycloakProvider>
	);
}

export default App;
